import React from "react";
import { CheckIcon, StarIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { volumes, Volume } from "../../data/landing";
export function VolumesSection() {
  return <Section tone="cream" cta="I want all 6 volumes" data-id="element-313" data-mp="2mvopqn1xhpzb">
      <SectionHeading eyebrow="What's inside" title={<>
            What I put inside the <em className="text-rose" data-id="element-315" data-mp="2e2lf0mio3r8d">Breast Augmentation Clinical Pathway™</em>
          </>} data-id="element-314" data-mp="2mx9g00h7mmrd" />
      <div className="mx-auto mt-12 max-w-3xl space-y-6" data-id="element-316" data-mp="2it1ra3ar56t5">
        {volumes.map(v => <VolumeCard key={v.number} volume={v} data-id="element-317" data-mp="244fea88lkr53" />)}
      </div>
    </Section>;
}
function VolumeCard({
  volume: v
}: {
  volume: Volume;
}) {
  const featured = v.featured;
  return <article className={`overflow-hidden rounded-3xl ${featured ? "bg-ink text-white shadow-xl ring-4 ring-rose/30" : "bg-white shadow-[0_1px_2px_rgba(23,33,63,0.06)]"}`} data-id="element-318" data-mp="2915pah5jowjn">
      {featured && <div className="flex items-center justify-center gap-2 bg-rose px-4 py-2.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-319" data-mp="1fiqt5icj5zei">
          <StarIcon className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-320" data-mp="1ajnmjtgwjl4f" />
          The heart of the system
        </div>}
      <div className="p-6 md:p-8" data-id="element-321" data-mp="1pf3mgf45yb8q">
        <p className={`font-serif text-sm font-bold uppercase tracking-[0.2em] ${featured ? "text-roseSoft" : "text-rose"}`} data-id="element-322" data-mp="1khtky13i294j">
          Volume {v.number}
        </p>
        <h3 className={`mt-2 font-serif text-2xl font-bold leading-tight md:text-3xl ${featured ? "text-white" : "text-ink"}`} data-id="element-323" data-mp="wqfslv5cmdjk">
          {v.title}
        </h3>
        <div className={`mt-4 space-y-3 text-[16px] leading-relaxed ${featured ? "text-white/85" : "text-inkSoft"}`} data-id="element-324" data-mp="16jdf0cdgomng">
          {v.intro.map(p => <p key={p} data-id="element-325" data-mp="e214bfmf1dmg">{p}</p>)}
        </div>

        {v.items && <>
            {v.listLabel && <p className={`mt-5 text-sm font-bold uppercase tracking-wide ${featured ? "text-white" : "text-ink"}`} data-id="element-326" data-mp="9250bgdpxm6w">
                {v.listLabel}
              </p>}
            {v.numbered ? <ol className="mt-4 space-y-2.5" data-id="element-327" data-mp="12rm9cuhuq7y5">
                {v.items.map((item, i) => <li key={item} className="flex items-center gap-3" data-id="element-328" data-mp="17kotyd4ni727" data-mpi={i}>
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white font-serif font-bold text-ink" data-id="element-329" data-mp="1cigt9s7mkvgf">
                      {i + 1}
                    </span>
                    <span className="text-[16px] font-medium text-white" data-id="element-330" data-mp="jtt8dxqsg83e">{item}</span>
                  </li>)}
              </ol> : <ul className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-331" data-mp="ov8rhk9eo4j5">
                {v.items.map(item => <li key={item} className="flex gap-2.5 text-[16px] leading-snug text-ink" data-id="element-332" data-mp="tpw8yz5zryo8">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-333" data-mp="20aozme6z7o64" />
                    {item}
                  </li>)}
              </ul>}
          </>}

        {v.outro?.map(p => <p key={p} className={`mt-5 rounded-xl p-4 text-[16px] font-semibold leading-relaxed ${featured ? "bg-white/10 text-white" : "bg-sand text-ink"}`} data-id="element-334" data-mp="3krepsllt23c2">
            {p}
          </p>)}
      </div>
    </article>;
}